export type CourtCaseFeeEntry = {
  value: number
  fee: number
}
export type CourtCaseFeeTables = Record<string, CourtCaseFeeEntry[]>

export const fetchFeeTables = async () => {
  const url = new URL(
    `${process.env.REACT_APP_AWS_ASSET_BUCKET_URL}/court-case-invoicing/court_case_fee_tables.json`
  )

  const json = await fetch(url, {
    method: 'GET',
    headers: {
      accept: 'application/json'
    }
  }).then((res) => res.json())

  if (!json || typeof json !== 'object') {
    throw new Error('Invalid JSON')
  }

  const parsed: CourtCaseFeeTables = {}

  for (const key of Object.keys(json)) {
    const arr = (json as Record<string, unknown>)[key]

    if (!Array.isArray(arr)) {
      continue
    }

    parsed[key] = arr.sort((a, b) => a.value - b.value)
  }

  return parsed
}
